export const UnsavedChangesClustersKey = 'clusters';
